export type { TSchedulingConfig } from '@hubertai/screening-question-types';
import type { TSchedulingConfig } from '@hubertai/screening-question-types';

export const DEFAULT_SCHEDULING_CONFIG: TSchedulingConfig = {
  provider: 'calcom',
  event_type_id: 0,
  cal_link: '',
  timezone: 'Europe/Stockholm',
};
